// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  ECO_WASTE_SERVICE_URL: "https://eco-waste-api-hfc8bpdrg3dqhna8.southeastasia-01.azurewebsites.net/api",
  ECO_WASTE_URL: "https://eco-waste-api-hfc8bpdrg3dqhna8.southeastasia-01.azurewebsites.net"
  // ECO_WASTE_SERVICE_URL: "https://eco-waste-api-uat.azurewebsites.net/api",
  // ECO_WASTE_URL: "https://eco-waste-api-uat.azurewebsites.net",
  // ECO_WASTE_SERVICE_URL: "https://eco-waste-api-non-pro-uat-fufuf6cmf7a7gnaw.southeastasia-01.azurewebsites.net/api",
  // ECO_WASTE_URL: "https://eco-waste-api-non-pro-uat-fufuf6cmf7a7gnaw.southeastasia-01.azurewebsites.net",
  // ECO_WASTE_SERVICE_URL: "https://localhost:44304/api",
  // ECO_WASTE_URL: "https://localhost:44304",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
